import { API_BASE_CMS,API_BASE_IMG_URl } from "helper/environment";
import { SlideshowData } from "components/interface";

// ✅ Configure includes for images + videos
const includes = [
  "field_ebt_slideshow",
  "field_ebt_slideshow.field_ebt_slideshow_slide",
  "field_ebt_slideshow.field_ebt_slideshow_slide.field_media_image",
  "field_ebt_slideshow.field_ebt_slideshow_slide.field_media_video_file",
  "field_ebt_slideshow.field_ebt_slideshow_slide.field_media_svg_image",
  "field_ebt_slideshow.field_slider_mobile_image",
  "field_ebt_slideshow.field_slider_mobile_image.field_media_image",
  "field_ebt_slideshow.field_slider_mobile_image.field_media_video_file",
  "field_ebt_slideshow.field_slider_mobile_image.field_media_svg_image"
];

export const getHomeApiData = async (PageId?: string): Promise<SlideshowData | null> => {
  const API_URL = `${API_BASE_CMS}/jsonapi/block_content/ebt_slideshow?include=${includes.join(",")}`;

  const res = await fetch(API_URL);
  const json = await res.json();
  const included = json.included || [];

  const findIncluded = (type: string, id: string) =>
    included.find((item: any) => item.type === type && item.id === id);


  const getMediaDataold = (mediaRel: any) => {
  if (!mediaRel?.data) return null;

  const mediaRef = Array.isArray(mediaRel.data) ? mediaRel.data[0] : mediaRel.data;
  if (!mediaRef?.type || !mediaRef?.id) return null;

  const media = findIncluded(mediaRef.type, mediaRef.id);
  if (!media) return null;

  const imageRel = media.relationships?.field_media_image?.data;
  const videoRel = media.relationships?.field_media_video_file?.data;

  const fileRel = imageRel || videoRel;
  if (!fileRel) return null;

  const fileRef = Array.isArray(fileRel) ? fileRel[0] : fileRel;
  if (!fileRef?.id) return null;

  const file = findIncluded(fileRef.type, fileRef.id);
  if (!file) return null;

  const url = file.attributes?.uri?.url
    ? `${API_BASE_IMG_URl}${file.attributes.uri.url}`
    : null;

  const mime = file.attributes?.filemime || "";
  const type: "image" | "video" = mime.startsWith("video/") ? "video" : "image";

  // ✅ Image ALT
  const alt =
    imageRel?.meta?.alt ||
    media.attributes?.name ||
    "";

  // ✅ Video title / name
  const title =
    type === "video"
      ? media.attributes?.name || file.attributes?.filename || ""
      : "";

  return { url,mime, type, alt, title };
};
const getMediaData = (mediaRel: any) => {
  if (!mediaRel?.data) return null;

  const mediaRef = Array.isArray(mediaRel.data) ? mediaRel.data[0] : mediaRel.data;
  const media = included.find(
    (item : any) => item.type === mediaRef.type && item.id === mediaRef.id
  );

  if (!media) return null;

  const imageRel = media.relationships?.field_media_image?.data;
  const videoRel = media.relationships?.field_media_video_file?.data;
  const svgRel = media.relationships?.field_media_svg_image?.data;

  const fileRel = imageRel || videoRel || svgRel;
  if (!fileRel) return null;

  const fileRef = Array.isArray(fileRel) ? fileRel[0] : fileRel;

  const file = included.find(
    (item:any) => item.type === fileRef.type && item.id === fileRef.id
  );

  if (!file) return null;

  const mime = file.attributes?.filemime || "";
  const url = file.attributes?.uri?.url
    ? `${API_BASE_IMG_URl}${file.attributes.uri.url}`
    : null;

  let type: "image" | "video" | "svg" = "image";

  if (mime.startsWith("video/")) type = "video";
  if (mime === "image/svg+xml") type = "svg";

  const alt =
    media.relationships?.field_media_image?.meta?.alt ||
    media.relationships?.field_media_svg_image?.meta?.alt ||
    media.attributes?.name ||
    "";

  const title =
    type === "video"
      ? media.attributes?.name || file.attributes?.filename || ""
      : "";

  return { url, type, mime, alt, title };
};

  // ✅ Find block by page name (optional)
  //console.log(json.data,"All EBT Data");
  const block = PageId
    ? json.data.find((b: any) => b.id === PageId)
    : json.data[0]; // fallback to first block

  if (!block) return null;

  const slides = block.relationships?.field_ebt_slideshow?.data
    ?.map((ref: any) => {
      const slide = findIncluded(ref.type, ref.id);
      if (!slide) return null;

      return {
        sliderid: slide.attributes?.drupal_internal__id || 0,
      //  slider_title: slide.attributes?.field_ebt_slideshow_title?.value || "",
        slider_tab_title: slide.attributes?.field_tab_title || "",
       
       // slider_description: slide.attributes?.field_ebt_slideshow_text?.value || "",
       slider_title:
            slide.attributes?.field_ebt_slideshow_title?.processed ||
            slide.attributes?.field_ebt_slideshow_title?.value ||
            "",

          slider_description:
            slide.attributes?.field_ebt_slideshow_text?.processed ||
            slide.attributes?.field_ebt_slideshow_text?.value ||
            "",
        slider_button_title: slide.attributes?.field_ebt_slideshow_link?.title || "",
        slider_button_link: slide.attributes?.field_ebt_slideshow_link?.uri.replace("internal:/", "") || "",
        destop_media: getMediaData(slide.relationships?.field_ebt_slideshow_slide),
        mobile_media: getMediaData(slide.relationships?.field_slider_mobile_image)
      };
    })
    .filter(Boolean) || [];

  return {
    id: block.attributes?.drupal_internal__id || 0,
    title: block.attributes?.field_title?.value || "",
    status: block.attributes?.status,
    description: block.attributes?.field_description?.value || "",
    main_sub_title: block.attributes?.field_main_sub_title || "",
    sub_title: block.attributes?.field_sub_title || "",
    button_url: block.attributes?.field_button_name?.uri.replace("internal:/", "") || "",
    button_title: block.attributes?.field_button_name?.title || "",
    slides
  };
};
